import { render } from "./Project.html?vue&type=template&id=1f79d206&scoped=true"
import script from "./Project.vue?vue&type=script&lang=ts"
export * from "./Project.vue?vue&type=script&lang=ts"

import "./Project.css?vue&type=style&index=0&id=1f79d206&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1f79d206"

export default script